import 'vite/modulepreload-polyfill'
import { createApp } from 'vue'
import { store } from './store/store.js'
import { Vue3SlideUpDown } from 'vue3-slide-up-down'
import CollapseTransition from '@ivanv/vue-collapse-transition/src/CollapseTransition.vue'
import App from './App.vue'
import router from './router'
import { googleAnalyticsTagManagerId } from '@/config.js'
import VueGtag from 'vue-gtag'
import { defineRule } from 'vee-validate'
import Rules from '@vee-validate/rules'

Object.keys(Rules).forEach(rule => {
  defineRule(rule, Rules[rule])
})

function mountVue () {
  const app = createApp(App)
  app.config.errorHandler = (error, vm, info) => {
    window.logError('vue', error.message, error.stack)
    console.error(error)
  }

  app.use(store)
  app.use(router)
  if (googleAnalyticsTagManagerId) {
    app.use(VueGtag, {
      config: {
        id: googleAnalyticsTagManagerId
      }
    }, router)
  }

  app.component('VueSlideUpDown', Vue3SlideUpDown)
  app.component('CollapseTransition', CollapseTransition)

  window.vue = app
  window.vue.router = router

  app.mount('#root')
}
window.mountVue = mountVue

if (document.getElementById('root')) {
  mountVue()
}
